// 帮助中心
export const helpLists = `/api/oauth/helpCenter/list`;
